import { AuthConfig } from '@intelliarts/ia-react-template';

export const NO_NAME_ADMIN_MENU_GROUP = '';
export const NO_NAME_OPEN_MENU_GROUP = ' ';

export const IA_PEOPLE_MENU_GROUP = 'IA People';
export const PROJECTS_MENU_GROUP = '  ';
export const HR_MENU_GROUP = 'HR';
export const ANALYTICS_MENU_GROUP = 'Analytics';
export const CONFIGURATION_MENU_GROUP = '   ';

export const ADMIN = 'ROLE_ADMIN';

const authConfig = new AuthConfig({
  profileUrl: 'users/me',
  roles: {
    ADMIN,
    ALL: 'all',
  }
});

export default authConfig;
